import { TableRow, TableRowProps } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'
import tableBodyRowStyles from '../../utils/components/CustomTable/styles/tableBodyRowStyles'
import { getStyles } from '../../utils/utils/commonUtils'

type ITableRowProps = TableRowProps &
  PropsWithChildren & {
    outline?: boolean
  }

const NewTableRow: FC<ITableRowProps> = ({
  children,
  outline,
  ...otherProps
}) => {
  const bodyRowClasses = getStyles(tableBodyRowStyles, {
    onRowClick: otherProps.onClick,
  })

  return (
    <TableRow
      className={'fx-nowrap'}
      sx={{
        // @ts-ignore
        ...bodyRowClasses.row,
        height: outline ? '46px' : null,
        outline: outline
          ? '5px solid rgba(93, 175, 239, 0.3) !important'
          : 'none',
        position: 'relative',
        zIndex: outline ? 10 : 1,
        '&:hover': {
          height: otherProps.onClick ? '46px' : undefined,
          outline: otherProps.onClick
            ? '5px solid rgba(93, 175, 239, 0.3) !important'
            : 'none',
          zIndex: otherProps.onClick ? 10 : 1,
        },
      }}
      {...otherProps}
    >
      {children}
    </TableRow>
  )
}

export default observer(NewTableRow)
